import { render, staticRenderFns } from "./Rg.vue?vue&type=template&id=4000472e&"
import script from "./Rg.vue?vue&type=script&lang=js&"
export * from "./Rg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports